<template>
  <div class="d-flex align-end py-2" style="width: 100%;" >
    <v-icon 
      v-if="icon" 
      class="mr-3"
      style="color: rgba(0, 0, 0, 0.38);"
    >
      {{ icon }}
    </v-icon>
    <div class="d-flex flex-column flex-grow-1">
      <div 
        v-if="showLabel" 
        class="text-subtitle-2 font-weight-bold"
        style="color: rgba(0, 0, 0, 0.5); font-size: 0.8em !important;"
      >
        {{ label }}
      </div>
      <div 
        class="px-2 py-1"
        style="border: 1px solid rgba(0, 0, 0, 0.15); border-radius: 4px;"
      >
        {{ formattedValue }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StaticField',
  props: {
    label: {
      type: String,
      required: false,
      default: '' 
    },
    icon: {
      type: String,
      required: false,
      default: null 
    },
    value: {
      type: [String, Number],
      required: false,
      default: '' 
    },
    showLabel: {
      type: Boolean,
      required: false,
      default: true,
    },
    currency: {
      type: String,
      required: false,
      default: null,
    }
  },
  computed: {
    formattedValue() {
      let stringValue = `${this.value}`;

      if (this.currency) {
        stringValue = `${this.currency}${this.value}`;
      }

      return stringValue;
    }
  }
}
</script>

<style scoped>
</style>